import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    image: { marginBottom: 35, marginTop: 20 },
  }),
);

export default useStyles;
